// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__3wjC-","mainGrid":"styles_mainGrid__2BxuE","firstGrid":"styles_firstGrid__21h3y","secondGrid":"styles_secondGrid__2tgPg"};